import { render, staticRenderFns } from "./index.vue?vue&type=template&id=666f0feb&scoped=true&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"
import style0 from "./index.vue?vue&type=style&index=0&id=666f0feb&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "666f0feb",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\project\\uniFrame\\uni-frame\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('666f0feb')) {
      api.createRecord('666f0feb', component.options)
    } else {
      api.reload('666f0feb', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=666f0feb&scoped=true&", function () {
      api.rerender('666f0feb', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/scrollTop/index.vue"
export default component.exports